import { GifsResult } from '@giphy/js-fetch-api'
import { createContext } from 'react'
import { Dimensions, Position, Range } from 'types'
import { MediaInfo, MediaSprite } from '../../types'
import { ArtboardFilter } from '../artboard-gl/types'
import { UGECropType, UGEEditor, UGEGAEventCallback, UGELayer, UGELayerProps } from './types'

export type EditorProps = {
    layerId?: string
    searchTerm?: string
}

interface UGEContextProps {
    activeEditor: UGEEditor
    activeEditorProps?: EditorProps
    apiKey: string
    crop?: Position
    cropType: UGECropType
    dimensions: Dimensions
    duration: number
    enableStickers: boolean
    filter?: ArtboardFilter
    filterIntensity?: number
    layers: UGELayer[]
    loaded: boolean
    paused: boolean
    reversed?: boolean
    source: File | string
    sourceInfo: MediaInfo | null
    sourceSprite: MediaSprite | null
    thumbnail: HTMLCanvasElement | null
    trim: Range
    addLayer: (layer: UGELayer) => void
    fetchFavoriteStickers?: (offset: number) => Promise<GifsResult>
    getProgress: () => number
    openEditor: (editor: UGEEditor, props?: EditorProps) => void
    removeLayerById: (id: string) => void
    resetEditorProps: () => void
    scrub: (progress: number) => void
    setCrop: (crop?: Position) => void
    setCropType: (cropType: UGECropType) => void
    setFilter: (filter?: ArtboardFilter) => void
    setFilterIntensity: (intensity: number) => void
    setLayers: (layers: UGELayer[]) => void
    setPaused: (paused: boolean) => void
    setReversed: (reversed: boolean) => void
    setTrim: (trim: Range) => void
    trackGAEvent: UGEGAEventCallback
    updateLayerById: (id: string, props: Partial<UGELayerProps>) => void
}

export const UGEContext = createContext({} as UGEContextProps)
